const getters = {
  orgid: state => state.user.orgid,
  orgname: state => state.user.orgname,
  platform: state => state.user.platform,
  role: state => state.user.role,
  mqtts: state => state.user.mqtts,
  sipinfo: state => state.user.sipinfo,
  isShangHai: state => state.user.isShangHai,
  moduletag: state => state.user.moduletag,
  personname: state => state.user.personname,
  syspersonjobnum: state => state.user.syspersonjobnum,
  syspersonid: state => state.user.syspersonid,
  customerservicetag: state => state.user.customerservicetag,
  LoginResp: state => state.user.LoginResp
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js